<script>
export default {
  name: 'DocumentIconSVG'
};
</script>

<template>
  <svg id="Icon_-_biz_comm_-_file-document-outline" data-name="Icon - biz comm  - file-document-outline" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path id="file-document-outline" d="M5.5,2A1.552,1.552,0,0,0,4,3.6V16.4A1.552,1.552,0,0,0,5.5,18h9A1.552,1.552,0,0,0,16,16.4V6.8L11.5,2h-6m0,1.6h5.25v4H14.5v8.8h-9V3.6M7,10v1.6h6V10H7m0,3.2v1.6h3.75V13.2Z" fill="#4d4d4d"/>
    <g id="Boundary" fill="none" stroke="#707070" stroke-width="1" opacity="0">
      <rect width="20" height="20" stroke="none"/>
      <rect x="0.5" y="0.5" width="19" height="19" fill="none"/>
    </g>
  </svg>
</template>
